import { Link } from 'react-router-dom'
import styles from './foot.module.css'

export const Foot = () => {
    return (
        <div className={styles.footer}>

            <div className={styles.bar}></div>

            <div className={styles.footertxt}>
                <p>Comercial Amaro - Todos los derechos reservados</p>
            </div>
            
        </div>
    )
}
